export const login_ru = {
  title: "Вход в личный кабинет",
  phone: 'Мобильный телефон',
  password: "Пароль",
  submit: "Войти"
};

export const login_kz = {
  title: "Логин каз",
  password: "Пароль каз",
  submit: "Войти каз"
};
